import { Image } from 'expo-image'
import { View } from 'react-native'

export const LogoHeader = () => {
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        padding: 6,
      }}
    >
      <Image
        style={{
          width: 100,
          height: 30,
        }}
        contentFit="contain"
        source={require('assets/routes/onboarding/logo_small.png')}
      />
    </View>
  )
}
